import "./hero.css";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import Button from "../../cards/buttons/Button";
import { profile } from "../../Object Files/profile";

const HERO_IMAGE = "/assets/bubbles.webp";

const leftVariant = {
  hidden: { x: -40, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: { type: "tween", ease: "easeOut", duration: 0.5 },
  },
};

const rightVariant = {
  hidden: { x: 40, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: { type: "tween", ease: "easeOut", duration: 0.5 },
  },
};

const Hero = ({ onClick }) => {
  return (
    <section id="home">
      <div className="hero-main-cont">
        <motion.div
          className="hero-flex"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
        >
          <motion.div className="hero-sub-cont-1" variants={leftVariant}>
            <p className="hero-greeting">
              Hello <span className="wave">👋</span>,
            </p>
            <div className="flex left_align">
              I am{" "}
              <span className="alt-text-yellow">
                <Typewriter
                  options={{
                    strings: [profile.name],
                    autoStart: true,
                    loop: true,
                    cursor: "|",
                    pauseFor: 4000,
                  }}
                />
              </span>
            </div>
            <p className="hero-role alt-text">{profile.title}</p>
            <h1 className="hero-main-text">{profile.tagline}</h1>
            <p className="hero-subline">
              {profile.experienceYears} years building products —{" "}
              <strong>{profile.backendYears}</strong> focused on APIs, databases,
              and production systems at{" "}
              <a
                href="https://grafenoilfieldltd.com"
                target="_blank"
                rel="noopener noreferrer"
                className="alt-text"
              >
                {profile.company}
              </a>
              .
            </p>

            <div className="btn-div">
              <button type="button" className="btn" onClick={onClick}>
                Hire Me
              </button>
              <Button
                href={profile.cvUrl}
                className="btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download CV
                <i className="fa-solid fa-download" aria-hidden="true"></i>
              </Button>
            </div>
          </motion.div>
          <motion.div className="hero-sub-cont" variants={rightVariant}>
            <img
              src={HERO_IMAGE}
              alt=""
              className="hero-img"
              loading="eager"
              decoding="async"
              fetchPriority="high"
              width={420}
              height={420}
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
